// The Tantric Temple mark: a gold line-drawn Ankh holding a lotus. viewBox -50 -50 100 100.
export const ANKH_PATHS = [
  "M0 -7 C -13 -16 -16 -47 0 -48 C 16 -47 13 -16 0 -7 Z",
  "M-6 -7.5 L-31 -12 Q -33 -4 -31 3.5 L-6 -1 M6 -7.5 L31 -12 Q 33 -4 31 3.5 L6 -1",
  "M-5 -1 L-12 46 L12 46 L5 -1",
  "M0 -19 C -3.5 -23 -3.5 -29 0 -34 C 3.5 -29 3.5 -23 0 -19 Z",
  "M0 -19 C -4 -20 -8 -23 -8.5 -28 C -4.5 -27 -1.5 -24 0 -19 M0 -19 C 4 -20 8 -23 8.5 -28 C 4.5 -27 1.5 -24 0 -19",
];
export const ANKH_JEWEL = { cx: 0, cy: -4, r: 3 };
